export const GOOGLE_MAP_URL = 'https://www.google.com/maps?q='

export const EMAJIN_EVENTS_URL = 'https://emajin.advisclient.com.au/events'

export const DATOCMS_ENDPOINT = {
  MAIN: 'https://graphql.datocms.com/',
  PREVIEW: '',
}

export const APP_LINK = {
  APP_STORE: 'https://apps.apple.com/au/app/emajin-golf/id6596770826',
  GOOGLE_PLAY: 'https://play.google.com/store/apps/details?id=golf.emajin',
}

export enum TicketKindId {
  GolfPlus = 'golfPlus',
  ClinicPlus = 'clinicPlus',
  Networking = 'networking',
}

export const EVENT_DURATION_HOURS = 1

export enum SocialLinkKindId {
  Facebook = 'facebook',
  Instagram = 'instagram',
  LinkedIn = 'linkedIn',
}

export enum OfficeAddressKindId {
  Sydney = 'Sydney',
  Melbourne = 'Melbourne',
  Brisbane = 'Brisbane',
}
